export const Currency = {
  USD: 'USD',
  BRL: 'BRL',
  EUR: 'EUR',
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]

export const PlanRecurrence = {
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
} as const

export type PlanRecurrence =
  (typeof PlanRecurrence)[keyof typeof PlanRecurrence]

export const ProductFeatureType = {
  ONE: 'One',
  PRO: 'Pro',
  MAX: 'Max',
  FREE: 'Free',
  // Not a plan anyone buys, and never offered by the pricing grid — but a
  // defined backend ordinal an account can sit on, so any response that
  // carries a plan can carry this one.
  TRIAL: 'Trial',
} as const

export type ProductFeatureType =
  (typeof ProductFeatureType)[keyof typeof ProductFeatureType]

/**
 * The three tiers a catalog SKU can belong to. Narrower than
 * ProductFeatureType on purpose: Free and Trial are account states, never
 * something the catalog sells.
 */
export const PlanTier = {
  ONE: 'One',
  PRO: 'Pro',
  MAX: 'Max',
} as const

export type PlanTier = (typeof PlanTier)[keyof typeof PlanTier]
